import { useId, useRef, useState } from 'react'
import { ArrowUpRight, Expand, X } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const screenFiles = [
  '01-merhaba.png',
  '02-masaustu.png',
  '03-dosyalar.png',
  '04-sohbet.png',
  '05-izinler.png',
  '06-cihazlar.png',
  '07-gece.png',
]

export default function ProductPreview({
  id = 'product-preview',
}: {
  id?: string
}) {
  const { t } = useTranslation('home')
  const screens = (
    t('preview.screens', { returnObjects: true }) as { label: string; caption: string }[]
  ).map((item, i) => ({ ...item, file: screenFiles[i] }))
  const [selected, setSelected] = useState(0)
  const dialog = useRef<HTMLDialogElement>(null)
  const dialogTitle = useId()
  const screen = screens[selected]
  return (
    <section
      className="official-preview"
      id={id}
      tabIndex={-1}
      aria-label={t('preview.sectionLabel')}
    >
      <div className="official-preview-label">
        <span>
          <span className="status-dot" /> {t('preview.statusLabel')}
        </span>
        <span>{t('preview.designLabel')}</span>
      </div>
      <div className="official-preview-frame">
        <div className="official-preview-top">
          <img src="/brand/mark.svg" width="34" height="25" alt="" />
          <span>
            CMDesk <small>Remote Desktop</small>
          </span>
          <span className="preview-tag">{t('preview.tag')}</span>
        </div>
        <button
          className="official-screen"
          onClick={() => dialog.current?.showModal()}
          aria-label={t('preview.enlargeAria', { label: screen.label })}
        >
          <img
            src={`/product/${screen.file}`}
            alt={t('preview.screenAlt', { label: screen.label })}
            width="1920"
            height="1080"
          />
          <span>
            <Expand size={15} /> {t('preview.enlarge')}
          </span>
        </button>
        <div className="official-screen-options" aria-label={t('preview.screenSelection')}>
          {screens.map((item, index) => (
            <button
              key={item.file}
              aria-pressed={selected === index}
              onClick={() => setSelected(index)}
            >
              {item.label}
            </button>
          ))}
        </div>
        <div className="official-preview-caption" aria-live="polite">
          <span>{screen.caption}</span>
          <span>{String(selected + 1).padStart(2, '0')} / 07</span>
        </div>
      </div>
      <div className="official-preview-bottom">
        <span>{t('preview.footnote')}</span>
        <a href="/preview/index.html" target="_blank" rel="noopener noreferrer">
          {t('preview.exploreAll')} <ArrowUpRight size={15} />
          <span className="sr-only"> {t('preview.newTab')}</span>
        </a>
      </div>
      <dialog
        ref={dialog}
        className="screen-dialog"
        aria-labelledby={dialogTitle}
        onClick={(event) => {
          if (event.target === event.currentTarget) dialog.current?.close()
        }}
      >
        <header>
          <h2 id={dialogTitle}>{t('preview.dialogTitle', { label: screen.label })}</h2>
          <button
            autoFocus
            onClick={() => dialog.current?.close()}
            aria-label={t('preview.closePreview')}
          >
            <X size={22} />
          </button>
        </header>
        <img
          src={`/product/${screen.file}`}
          width="1920"
          height="1080"
          alt={t('preview.dialogAlt', { label: screen.label })}
        />
        <p>{t('preview.disclaimer')}</p>
      </dialog>
    </section>
  )
}
